import {showConfirm, showPrompt} from '$lib/components/Dialogs.svelte';
import {toast} from '@zerodevx/svelte-toast';
import type {SvelteComponent} from 'svelte';

type SvelteToastOnPopCallback = (id?: number | undefined) => any;

type SvelteToastCustomComponent = {
    /**
     * - custom Svelte Component
     */
    src: SvelteComponent;
    /**
     * - props to pass into custom component
     */
    props?:
        | {
              [x: string]: any;
          }
        | undefined;
    /**
     * - forward toast id to prop name
     */
    sendIdTo?: string | undefined;
};

type SvelteToastOptions = {
    /**
     * - unique id generated for every toast
     */
    id?: number | undefined;
    /**
     * - container target name to send toast to
     */
    target?: string | undefined;
    /**
     * - toast message
     */
    msg?: string | undefined;
    /**
     * - duration of progress bar tween from initial to next
     */
    duration?: number | undefined;
    /**
     * - initial progress bar value
     */
    initial?: number | undefined;
    /**
     * - next progress bar value
     */
    next?: number | undefined;
    /**
     * - pause progress bar tween on mouse hover
     */
    pausable?: boolean | undefined;
    /**
     * - allow dissmiss with close button
     */
    dismissable?: boolean | undefined;
    /**
     * - display toasts in reverse order
     */
    reversed?: boolean | undefined;
    /**
     * - toast intro fly animation settings
     */
    intro?: import('svelte/transition').FlyParams | undefined;
    /**
     * - css var overrides
     */
    theme?:
        | {
              [x: string]: string | number;
          }
        | undefined;
    /**
     * - user-defined classes
     */
    classes?: string[] | undefined;
    /**
     * - callback that runs on toast dismiss
     */
    onpop?: SvelteToastOnPopCallback | undefined;
    /**
     * - send custom Svelte Component as a message
     */
    component?: SvelteToastCustomComponent | undefined;
    /**
     * - DEPRECATED
     */
    progress?: number | undefined;
};

export function tSuccess(message: string, options?: SvelteToastOptions): number {
    return toast.push(escapeHtml(message), {
        target: 'notifications',
        classes: ['toast-success'],
        ...options,
    } as any);
}

export function tError(message: string, options?: SvelteToastOptions): number {
    return toast.push(escapeHtml(message), {
        target: 'notifications',
        classes: ['toast-error'],
        ...options,
    } as any);
}

export function tRemove(id: number) {
    return toast.pop(id);
}

export function tSet(id: number, message: string, options?: SvelteToastOptions) {
    options = options || {};
    options.msg = escapeHtml(message);

    return toast.set(id, options as any);
}

export function tConfirm(message: string, title = 'Подтверждение', okText = 'Ok', cancelText = 'Отмена'): Promise<boolean> {
    return showConfirm(message, title, okText, cancelText);
}

export async function tPrompt(title = 'Введите значение', defValue = '', okText = 'Ok', cancelText = 'Отмена'): Promise<string | null> {
    return showPrompt(title, defValue, okText, cancelText);
}

function escapeHtml(htmlStr: string) {
    return htmlStr.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
